import "GIS/UI/Map";
import 'GIS/Map/OL3';
import 'GIS/Map/Layer/MapBox';
import 'GIS/Map/Layer/OSM';
import 'GIS/Map/Layer/GlonassVector';
import Velocity from 'velocity-animate';
import "./Input";

NS('UI.Widget.Forms.Control');

UI.Widget.Forms.Control.Feature = Class(UI.Widget.Forms.Control.Input, {
    /** @type {GIS.UI.Map} */
    map: null,
    $input: null,
    $button: null,

    createElement()
    {
        this.ParentCall();

        this.$input = this.$element;
        this.$input.addClass('flex-item');
        this.$button = $('<button class="feature-control-bind flex-item">Привязать</button>');

        this.$element = $('<div class="feature-control flex"></div>');
        this.$element.append(this.$input, this.$button);
    },

    updateElement(value)
    {
        this.$input.val(value == null ? undefined : value);
        this.map.align();
    },

    removeElement()
    {
        this.ParentCall();

        this.$input = this.$button = null;
        this.map && this.map.destroy();
    },

    listenElement()
    {
        var current;

        this.$element.on('click', 'button', () => {
            this.openMap()
                .then((map) => {
                    const source = Util.create(Util.coalesce(this.$control.attr('feature-source'), 'GIS.Data.LayerFeatures'));
                    const value = this.getValue();

                    if (value) {
                        return source.getDocument({ id: value })
                            .then((data) => {
                                const item = data.item;
                                const extent = Util.coalesce(_.get(item, 'extent'), _.get(item, 'feature.extent'));

                                if (extent) {
                                    map.fit(map.transformExtentProjection(extent, GLONASS_PROJ, map.getProjection()));
                                }

                                return map;
                            });
                    }

                    return map;
                })
                .then((map) => Promise.all([
                    map,
                    map.showLayer(this.$control.attr('layer'), true)
                ]))
                .then(([map, layer]) => {
                    const value = this.getValue();

                    const afterLoad = () => {
                        current = layer.getFeature(value);

                        if (current) {
                            layer.setFeatureStyleName(current, 'current');
                            layer.off('after.load', afterLoad);
                        }
                    };

                    layer.on('after.load', afterLoad)
                        .on('feature.select', ({ feature }) => {
                            if (current) {
                                layer.setFeatureStyleName(current, 'default');
                            }

                            current = feature;
                            layer.setFeatureStyleName(current, 'current');
                            this.setValue(current.get('id'), true);
                        })
                        .on('feature.unselect', ({ feature }) => {
                            current = null;
                            layer.setFeatureStyleName(feature, 'default');
                            this.setValue(null, true);
                        });
                })
                .catch(err => console.warn(err.stack));
        });
    },

    openMap()
    {
        // todo get map options from control attributes
        this.map = new GIS.UI.Map(this, {
            'class': Util.coalesce( _.get( global, this.$control.attr('map') ), GIS.Map.OL3 ),
            layersSourceClass: Util.coalesce(this.$control.attr('layer-source'), 'GIS.Data.Layers'),
            featuresSourceClass: Util.coalesce(this.$control.attr('feature-source'), 'GIS.Data.LayerFeatures'),
        });

        const $map_container = $(`
        <div class="map-wraper" style="width: 100%;height: 100%; position: fixed; z-index: 99999">
            <div class="overlay"></div>
            <div class="feature-select-map" name="feature-select-map">
                <div class="close gl-pointer"><i class="icon-32 icon-close"></i></div>
            </div>
        </div>`).appendTo(document.body);

        const $map = $('.feature-select-map', $map_container);
        $map.on('click', '.close', () => this.map.destroy());

        this.map.on('destroy', () => {
            Velocity($map, 'reverse').then(() => {
                $map.remove();
                $map_container.remove();
                this.map = null;
            });
        });

        return Velocity($map, {
            scaleX: [1, 0],
            scaleY: [1, 0],
            translateX: ['-50%', '-50%'],
            translateY: ['-50%', '-50%'],
            opacity: [1, 0]
        }, {
            duration: 500,
            easing: 'easeOutCubic'
        }).then(() => this.map.render().appendTo($map));
    }
});
